export const EventManagementPaths = {
    eventForm: ":eventType/:eventName",
} as const;
